/**
 * StreamWebhookEventData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StreamWebhookEventData
 */
export interface StreamWebhookEventData {
  /** 主键ID */
  id?: string
  /** [R] X-Webhook-Id，用于去重 */
  webhook_id?: string
  /** [R] X-Webhook-Attempt，重试次数 */
  attempt?: number
  /** [R] X-Signature，签名 */
  signature?: string
  /** [R] 完整请求头 JSON */
  raw_headers?: Record<string, string>
  /** [R] 原始请求体（source of truth） */
  raw_body?: string
  /** [I] 事件类型：message.new, message.read 等 */
  event_type?: string
  /** [I] 频道 CID：direct:xxx, camp:xxx 等 */
  cid?: string
  /** [I] 频道类型：direct, camp, battle */
  channel_type?: string
  /** [I] 频道 ID */
  channel_id?: string
  /** [I] 消息 ID（如有） */
  message_id?: string
  /** [I] 触发用户 ID */
  user_id?: string
  /** [P] 处理状态 */
  process_status?: string
  /** [P] 错误信息 */
  process_error?: string
  /** [P] 处理完成时间 */
  processed_at?: string
  /** [T] Stream 事件时间 */
  event_created_at?: string
  /** [T] 本地接收时间（分区键） */
  received_at?: string
  /** [T] 记录创建时间 */
  created_at?: string
}

/**
 * StreamWebhookEventData Schema
 */
export const StreamWebhookEventDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '主键ID',
      format: 'string',
      type: 'string',
      label: '主键ID',
    },
    webhook_id: {
      description: '[R] X-Webhook-Id，用于去重',
      format: 'string',
      type: 'string',
    },
    attempt: {
      description: '[R] X-Webhook-Attempt，重试次数',
      format: 'int',
      type: 'integer',
    },
    signature: {
      description: '[R] X-Signature，签名',
      format: 'string',
      type: 'string',
    },
    raw_headers: {
      additionalProperties: {
        format: 'string',
        type: 'string',
      },
      description: '[R] 完整请求头 JSON',
      format: 'map[string]string',
      type: 'object',
    },
    raw_body: {
      description: '[R] 原始请求体（source of truth）',
      format: 'string',
      type: 'string',
    },
    event_type: {
      description: '[I] 事件类型：message.new, message.read 等',
      format: 'string',
      type: 'string',
    },
    cid: {
      description: '[I] 频道 CID：direct:xxx, camp:xxx 等',
      format: 'string',
      type: 'string',
    },
    channel_type: {
      description: '[I] 频道类型：direct, camp, battle',
      format: 'string',
      type: 'string',
    },
    channel_id: {
      description: '[I] 频道 ID',
      format: 'string',
      type: 'string',
    },
    message_id: {
      description: '[I] 消息 ID（如有）',
      format: 'string',
      type: 'string',
    },
    user_id: {
      description: '[I] 触发用户 ID',
      format: 'string',
      type: 'string',
    },
    process_status: {
      description: '[P] 处理状态',
      format: 'cons.StreamWebhookProcessStatus',
      type: 'string',
    },
    process_error: {
      description: '[P] 错误信息',
      format: 'string',
      type: 'string',
    },
    processed_at: {
      description: '[P] 处理完成时间',
      format: '*time.Time',
      type: 'string',
    },
    event_created_at: {
      description: '[T] Stream 事件时间',
      format: '*time.Time',
      type: 'string',
    },
    received_at: {
      description: '[T] 本地接收时间（分区键）',
      format: '*time.Time',
      type: 'string',
    },
    created_at: {
      description: '[T] 记录创建时间',
      format: '*time.Time',
      type: 'string',
    },
  },
  type: 'object',
}
